import * as types from 'store/actions/types';

const INITIAL_STATE = {
	loading: false,
	error: false,
	data: []
};

export default function(state = INITIAL_STATE, action = {}) {
	switch (action.type) {
		case types.PRODUCT_PACKETS_LOADING:
			return {
				...state,
				loading: true,
				error: false
			};
		case types.PRODUCT_PACKETS_SUCCESS:
			return {
				...state,
				loading: false,
				error: false,
				data: action.payload
			};
		case types.PRODUCT_PACKETS_ERROR:
			return {
				...state,
				loading: false,
				error: true
			};
		case types.PRODUCT_PACKETS_CLEAR:
			return INITIAL_STATE;
		default:
			return state;
	}
}
